import { useSelector } from 'react-redux';
import { selectAdsManagedEnabled, selectSitePublicLoaded } from '../store/reducers/sitePublicReducer';

/** Server-driven managed ads (Website.adsManagedEnabled); waits until /api/v1/public/site-settings has loaded. */
export function useSiteAdsManaged() {
  const sitePublicLoaded = useSelector(selectSitePublicLoaded);
  const adsManagedEnabled = useSelector(selectAdsManagedEnabled);
  return { sitePublicLoaded, adsManagedEnabled };
}
